import { SofturaTable } from "client/CommonComponents";

const AssetPoolPopup = (props: any) => {
  const activeRowData = (item: any) => {
    return props.activeRow(item);
  };
  const columns = [
    {
      key: "Pick",
      title: "Pick",
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(_e: any) => {
              props.setAssetPoolError("");
              activeRowData(row);
            }}
          >
            <input
              className="grid-radio-btn"
              type="radio"
              id={row.id}
              name="pick"
             data-attribute="AssetPoolPopup_pick_Input" />
          </a>
        );
      },
      width: 70,
      style: { "text-align": "center" },
    },
    {
      key: "poolCenter",
      title: "Pool Center",
      width: 100,
    },
    {
      key: "assetNo",
      title: "Asset#",
      width: 70,
    },
    {
      key: "unitNo",
      title: "Unit#",
      width: 70,
    },
    {
      key: "description",
      title: "Description",
      width: 220,
    },
    {
      key: "year",
      title: "Year",
      width: 70,
    },
    {
      key: "manufacturer",
      title: "Manufacturer",
      width: 100,
    },
    {
      key: "serialNo",
      title: "Serial/VIN",
      width: 80,
    },
    {
      key: "gvw",
      title: "GVW",
      width: 80,
    },
    {
      key: "eqClass",
      title: "Eq Class",
      width: 80,
    },
    {
      key: "po",
      title: "CIP PO",
      width: 80,
    },
    {
      key: "cipOrder",
      title: "CIP Order",
      width: 100,
    },
    {
      key: "allocatedTo",
      title: "Allocated To",
      width: 100,
    },
  ];
  return (
    <div className="pool-grid-block">
      {!!props.errorMessage && (
        <div className="pick-pool-error">{props.errorMessage}</div>
      )}
      <div className={props?.poolGridData?.length !== 0 ? "softura-table" : "softura-table paginationNav"}>
        <SofturaTable data={props?.poolGridData} columns={columns} sort={true} filter={true} data-attribute="AssetPoolPopup_Default_Grid" />
      </div>     
    </div>
  );
};

export default AssetPoolPopup;
